<template>
    <div class="form-group">
        <label :class="labelClass" :for="referenceId" v-html="label + [required ? '*' : '']"/>
        <slot/>
        <div class="invalid-feedback" v-if="error" v-html="error"/>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        labelClass: {
            type: String,
        },
        referenceId: {
            type: String,
            required: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
        error: String,
    },
}
</script>
